import React from 'react';
import LogoutContainer from 'bundles/LoginRegister/containers/LogoutContainer';

const LogoutScene = (props) => {
    return (
        <LogoutContainer {...props} />
    );
};

export default LogoutScene;
